import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { vipPerks } from "@/mocks/home";

export default function Vip() {
  return (
    <section id="vip" className="scroll-mt-section bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="VIP 特权"
            tone="dark"
            title="VIP 会员的六项特权"
            subtitle="在标准会员的基础上，VIP 进一步覆盖画质、缓存与身份展示等方向，适合观看频率较高的用户。"
            align="center"
          />
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {vipPerks.map((perk, index) => (
            <Reveal key={perk.title} delay={index * 80}>
              <article className="h-full rounded-lg bg-foreground-900 border border-foreground-800 p-5 md:p-6">
                <span className="w-12 h-12 rounded-lg bg-primary-500/15 text-primary-300 flex items-center justify-center text-2xl">
                  <i className={perk.icon} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-background-50">
                  {perk.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-300 leading-relaxed">{perk.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={160}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-5 rounded-lg bg-gradient-to-r from-primary-600 to-accent-600 p-6 md:p-8">
            <div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">
                想直接对比会员与 VIP？
              </h3>
              <p className="mt-1.5 text-sm text-background-100">
                回到会员体系分区查看三种档位的功能差异。
              </p>
            </div>
            <a
              href="#membership"
              className="inline-flex items-center gap-2 rounded-md bg-background-50 text-foreground-950 text-sm font-medium px-5 py-2.5 whitespace-nowrap transition-colors hover:bg-background-100"
            >
              <i className="ri-arrow-up-line" />
              对比会员档位
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}